import React from 'react';
import Button from '../components/Button';

import Success from '../images/icons/success.svg';

import Api from '../Api';

import './Apply.less';

export default class Apply extends React.Component {
  constructor(props) {
    super(props);

    this.success = this.success.bind(this);
    this.submit = this.submit.bind(this);

    this.state = {
      success: false,
      error: null
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  success() {
    return (
      <div className="apply-component page-flyout success">
        <div className="image-wrapper"><img role="presentation" src={Success} /></div>
        <h2>Application Submitted!</h2>
        <p className="note">Thank you for your application.<br />We will get back to you within 48 hours.</p>
      </div>
    );
  }

  submit() {
    let payload = Api.Utils.getFormValues(
      this,
      [
        'company_name',
        'url',
        'name',
        'email_address',
        'phone_number',
        'note'
      ]
    );

    return Api.brandLead(payload).then(
      () => {
        this.setState({success: true});
      }
    );
  }

  render() {
    if (this.state.success) {
      return this.success();
    }

    return (
      <div className="apply-component page-flyout">
        <h2>Apply to Sell</h2>
        <p className="note">Apply to sell on Indigo Fair to get access to thousands of local retailers.</p>
        <div className="input"><input type="text" ref="company_name" placeholder="Company Name" /></div>
        <div className="input"><input type="text" ref="url" placeholder="Website" /></div>
        <div className="input"><input type="text" ref="name" placeholder="Your Name" /></div>
        <div className="input"><input type="text" ref="email_address" placeholder="Email Address" /></div>
        <div className="input"><input type="text" ref="phone_number" placeholder="Phone Number" /></div>
        <div className="input note-input">
          <label htmlFor="note">Note</label>
          <textarea name="note" ref="note" />
        </div>
        <div><Button onClick={this.submit}>Submit</Button></div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/Apply.js
 **/